// extracted by mini-css-extract-plugin
module.exports = {"stretchdelay":"index-stretchdelay-23HbM"};